import React, { useState, useEffect } from 'react';
import { Form, Button, Spinner, Row, Col, Alert } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../../utils/httpProvider';
import { KETQUATUYENSINH_API, NGANH_API, CHUYENNGANH_API, HINHTHUCDAOTAO_API, DECUONGNGHIENCUU_API, HOSO_TUYENSINH_API, DANHGIA_THISINH_API, BaseGatewayImage } from '../../../../../utils/apiUrl';
import { objectKetQuaTuyenSinh, ketQuaTuyenSinhValue, objectThoiHanDaoTao, trangThaiGuiKetQuaValue, objectLoaiCanBoHuongDan } from '../../../../../utils/define';
import DocumentInput from '../../../../../components/document-input/DocumentInput';
import Editor from '../../../../../components/editor/Editor';
import { ConfirmModal } from '../../../../../modules/modal/ConfirmModal';

const KetQuaTuyenSinhTab = ({ hoSoId, deCuongId, loaiTuyenSinh = 0, readOnly = false }) => {
    const [formData, setFormData] = useState({
        id: null,
        hoSoTuyenSinhId: hoSoId,
        ketQua: ketQuaTuyenSinhValue.trungTuyen,
        diemXetTuyen: 0,
        diemHoSo: 0,
        diemTong: 0,
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        canBoHuongDan: '',
        donViCongTac: '',
        thoiHanDaoTao: null,
        tuNgay: '',
        denNgay: '',
        fileQuyetDinh: '',
        thongBaoNhapHoc: '',
        nganhDaoTaoId: null,
        maNganhDaoTao: '',
        nganhDaoTao: '',
        chuyenNganhDaoTaoId: null,
        hinhThucDaoTaoId: null,
        tenDeTai: '',
        ghiChu: '',
        quyCheDaoTao: ''
    });
    const [saving, setSaving] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [canBoList, setCanBoList] = useState([]);

    // Fetch existing KetQuaTuyenSinh
    const { data: ketQuaRes, isLoading, refetch } = useQuery(
        ['ketQuaTuyenSinhData', hoSoId],
        () => Get(KETQUATUYENSINH_API.GET_PAGING, null, { pageIndex: 1, pageSize: 1, HoSoTuyenSinhId: hoSoId }),
        { enabled: !!hoSoId }
    );

    // Dictionaries
    const { data: nganhRes } = useQuery(['nganhDaoTaoList_KetQua'], () => Get(NGANH_API.GET_PAGING, null, { pageIndex: 1, pageSize: 1000 }));
    const { data: chuyenNganhRes } = useQuery(['chuyenNganhDaoTaoList_KetQua'], () => Get(CHUYENNGANH_API.GET_PAGING, null, { pageIndex: 1, pageSize: 1000 }));
    const { data: hinhThucRes } = useQuery(['hinhThucDaoTaoList_KetQua'], () => Get(HINHTHUCDAOTAO_API.GET_ALL_PAGING, null, { pageIndex: 1, pageSize: 1000 }));
    
    // Fetch DeCuongNghienCuu to get default TenDeTai
    const { data: deCuongRes } = useQuery(
        ['deCuongNghienCuu_KetQua', hoSoId],
        () => Get(DECUONGNGHIENCUU_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: hoSoId }),
        { enabled: !!hoSoId }
    );

    const { data: hoSoRes } = useQuery(
        ['hoSoTuyenSinhDetail_KetQua', hoSoId], 
        () => Get(HOSO_TUYENSINH_API.GET_ITEM, hoSoId), 
        { enabled: !!hoSoId }
    );
    const dataHoSo = hoSoRes?.data || hoSoRes || {};

    const { data: danhGiaRes } = useQuery(
        ['danhGiaThiSinh_KetQua', hoSoId], 
        () => Get(`${DANHGIA_THISINH_API.GET_BY_HOSO_ID}/${hoSoId}`),
        { enabled: !!hoSoId }
    );
    const danhGiaThiSinh = danhGiaRes?.data || danhGiaRes || null;

    const nganhOptions = nganhRes?.data?.data || nganhRes?.data?.$values || nganhRes?.data || [];
    const chuyenNganhOptions = chuyenNganhRes?.data?.data || chuyenNganhRes?.data?.$values || chuyenNganhRes?.data || [];
    const hinhThucOptions = hinhThucRes?.data?.data || hinhThucRes?.data?.$values || hinhThucRes?.data || [];

    const selectedNganh = dataHoSo?.nganhId ? nganhOptions.find(x => x.id === dataHoSo.nganhId || x.Id === dataHoSo.nganhId) : null;
    const selectedChuyenNganh = dataHoSo?.chuyenNganhId ? chuyenNganhOptions.find(x => x.id === dataHoSo.chuyenNganhId || x.Id === dataHoSo.chuyenNganhId) : null;
    const hasChuyenNganh = dataHoSo?.nganhId ? chuyenNganhOptions.some(x => x.nganhId === dataHoSo.nganhId || x.NganhId === dataHoSo.nganhId) : false;

    useEffect(() => {
        let isUpdated = false;
        let newState = { ...formData };

        if (ketQuaRes && ketQuaRes.data) {
            let items = [];
            if (Array.isArray(ketQuaRes.data)) items = ketQuaRes.data;
            else if (Array.isArray(ketQuaRes.data.data)) items = ketQuaRes.data.data;
            else if (Array.isArray(ketQuaRes.data.$values)) items = ketQuaRes.data.$values;
            
            if (items.length > 0) {
                const item = items[0];
                const rawKetQua = item.ketQua !== undefined ? item.ketQua : item.KetQua;
                let parsedKetQua = ketQuaTuyenSinhValue.khongTrungTuyen;
                if (rawKetQua === 0 || String(rawKetQua) === '0' || String(rawKetQua).toLowerCase() === 'trungtuyen') {
                    parsedKetQua = ketQuaTuyenSinhValue.trungTuyen;
                } else if (rawKetQua === 1 || String(rawKetQua) === '1' || String(rawKetQua).toLowerCase() === 'khongtrungtuyen') {
                    parsedKetQua = ketQuaTuyenSinhValue.khongTrungTuyen;
                } else if (rawKetQua === 2 || String(rawKetQua) === '2' || String(rawKetQua).toLowerCase() === 'trungtuyencanbosung') {
                    parsedKetQua = ketQuaTuyenSinhValue.trungTuyenCanBoSung;
                }

                const rawThoiHan = item.thoiHanDaoTao !== undefined ? item.thoiHanDaoTao : (item.ThoiHanDaoTao !== undefined ? item.ThoiHanDaoTao : null);
                let parsedThoiHan = null;
                if (rawThoiHan === 0 || String(rawThoiHan) === '0' || (typeof rawThoiHan === 'string' && rawThoiHan.toLowerCase() === 'banam')) {
                    parsedThoiHan = 0;
                } else if (rawThoiHan === 1 || String(rawThoiHan) === '1' || (typeof rawThoiHan === 'string' && rawThoiHan.toLowerCase() === 'bonnam')) {
                    parsedThoiHan = 1;
                }

                newState = {
                    ...newState,
                    id: item.id || item.Id,
                    hoSoTuyenSinhId: item.hoSoTuyenSinhId || item.HoSoTuyenSinhId,
                    ketQua: parsedKetQua,
                    diemXetTuyen: item.diemXetTuyen !== undefined ? item.diemXetTuyen : item.DiemXetTuyen,
                    diemHoSo: item.diemHoSo !== undefined ? item.diemHoSo : item.DiemHoSo,
                    diemTong: item.diemTong !== undefined ? item.diemTong : item.DiemTong,
                    soQuyetDinh: item.soQuyetDinh || item.SoQuyetDinh || '',
                    ngayQuyetDinh: item.ngayQuyetDinh ? item.ngayQuyetDinh.split('T')[0] : (item.NgayQuyetDinh ? item.NgayQuyetDinh.split('T')[0] : ''),
                    canBoHuongDan: item.canBoHuongDan || item.CanBoHuongDan || '',
                    loaiCanBoHuongDan: item.loaiCanBoHuongDan !== undefined ? item.loaiCanBoHuongDan : null,
                    donViCongTac: item.donViCongTac || item.DonViCongTac || '',
                    thoiHanDaoTao: parsedThoiHan,
                    tuNgay: item.tuNgay ? item.tuNgay.split('T')[0] : (item.TuNgay ? item.TuNgay.split('T')[0] : ''),
                    denNgay: item.denNgay ? item.denNgay.split('T')[0] : (item.DenNgay ? item.DenNgay.split('T')[0] : ''),
                    fileQuyetDinh: item.fileQuyetDinh || item.FileQuyetDinh || '',
                    thongBaoNhapHoc: item.thongBaoNhapHoc || item.ThongBaoNhapHoc || '',
                    nganhDaoTaoId: dataHoSo.nganhId || null,
                    hinhThucDaoTaoId: item.hinhThucDaoTaoId || item.HinhThucDaoTaoId || null,
                    tenDeTai: item.tenDeTai || item.TenDeTai || '',
                    trangThaiGuiKetQua: item.trangThaiGuiKetQua !== undefined ? item.trangThaiGuiKetQua : (item.TrangThaiGuiKetQua !== undefined ? item.TrangThaiGuiKetQua : 0),
                    ghiChu: item.ghiChu || item.GhiChu || '',
                    quyCheDaoTao: item.quyCheDaoTao || item.QuyCheDaoTao || ''
                };
                isUpdated = true;

                // parse canBoList
                const rawCb = item.canBoHuongDan || item.CanBoHuongDan || '';
                if (rawCb) {
                    const parsedCbList = rawCb.split('\n').filter(Boolean).map(line => {
                        const parts = line.split(' - ');
                        let vaiTroVal = null;
                        let donVi = '';
                        
                        if (parts.length >= 3) {
                            const vaiTroLabel = parts[2].trim();
                            const found = objectLoaiCanBoHuongDan.find(x => x.label.toLowerCase() === vaiTroLabel.toLowerCase());
                            if (found) vaiTroVal = found.value;
                            donVi = parts[1].trim();
                        } else if (parts.length === 2) {
                            const labelOrDonVi = parts[1].trim();
                            const found = objectLoaiCanBoHuongDan.find(x => x.label.toLowerCase() === labelOrDonVi.toLowerCase());
                            if (found) {
                                vaiTroVal = found.value;
                                donVi = ''; // It was a role, so unit is empty
                            } else {
                                donVi = labelOrDonVi; // It was a unit, role is empty
                                if (item.loaiCanBoHuongDan !== undefined && item.loaiCanBoHuongDan !== null) {
                                    vaiTroVal = item.loaiCanBoHuongDan;
                                }
                            }
                        } else if (parts.length === 1) {
                            if (item.loaiCanBoHuongDan !== undefined && item.loaiCanBoHuongDan !== null) {
                                vaiTroVal = item.loaiCanBoHuongDan;
                            }
                        }
                        
                        return {
                            ten: parts[0] ? parts[0].trim() : '',
                            donVi: donVi,
                            vaiTro: vaiTroVal
                        };
                    });
                    setCanBoList(parsedCbList);
                }
            }
        }

        // Set default TenDeTai and CanBoHuongDan from DeCuongNghienCuu if empty
        if (deCuongRes && deCuongRes.data) {
            let deCuongData = null;
            if (Array.isArray(deCuongRes.data) && deCuongRes.data.length > 0) {
                deCuongData = deCuongRes.data[0];
            } else if (deCuongRes.data.$values && deCuongRes.data.$values.length > 0) {
                deCuongData = deCuongRes.data.$values[0];
            } else if (!Array.isArray(deCuongRes.data) && !deCuongRes.data.$values) {
                deCuongData = deCuongRes.data;
            }

            if (deCuongData) {
                // Set default TenDeTai
                if (!newState.tenDeTai) {
                    const tenDeCuong = deCuongData.tenDeCuong || deCuongData.TenDeCuong;
                    if (tenDeCuong) {
                        newState.tenDeTai = tenDeCuong;
                        isUpdated = true;
                    }
                }

                // Set default CanBoHuongDan from DeCuongNghienCuu's CanBoHuongDans
                if (!newState.canBoHuongDan && canBoList.length === 0) {
                    const cbList = deCuongData.canBoHuongDans || deCuongData.CanBoHuongDans || deCuongData.canBoHuongDans?.$values || [];
                    const dsCanBo = Array.isArray(cbList) ? cbList : (cbList.$values || []);
                    if (dsCanBo.length > 0) {
                        const customLoaiCanBoMap = { canBoHuongDanChinh: 0, canBoHuongDanPhu: 1, dongHuongDan: 2 };
                        const parsedList = dsCanBo.map(cb => {
                            let parsedVaiTro = cb.loaiCanBoHuongDan !== undefined ? cb.loaiCanBoHuongDan : null;
                            if (typeof parsedVaiTro === 'string') {
                                if (customLoaiCanBoMap[parsedVaiTro] !== undefined) {
                                    parsedVaiTro = customLoaiCanBoMap[parsedVaiTro];
                                } else {
                                    const match = Object.keys(customLoaiCanBoMap).find(k => k.toLowerCase() === parsedVaiTro.toLowerCase());
                                    if (match) parsedVaiTro = customLoaiCanBoMap[match];
                                    else if (!isNaN(parsedVaiTro)) parsedVaiTro = parseInt(parsedVaiTro);
                                }
                            }
                            return {
                                ten: cb.hoTen || cb.HoTen || '',
                                donVi: cb.donViCongTac || cb.DonViCongTac || '',
                                vaiTro: parsedVaiTro
                            };
                        });
                        setCanBoList(parsedList);
                        isUpdated = true;
                    }
                }
            }
        }

        if (isUpdated) {
            setFormData(newState);
        }
    }, [ketQuaRes, deCuongRes]);

    useEffect(() => {
        if (danhGiaThiSinh && danhGiaThiSinh.id) {
            setFormData(prev => ({ 
                ...prev, 
                diemXetTuyen: danhGiaThiSinh.diemDeCuong !== null ? danhGiaThiSinh.diemDeCuong : 0,
                diemHoSo: danhGiaThiSinh.diemHoSo !== null ? danhGiaThiSinh.diemHoSo : 0,
                diemTong: danhGiaThiSinh.diemTong !== null ? danhGiaThiSinh.diemTong : 0
            }));
        }
    }, [danhGiaThiSinh]);

    const handleSave = async (isSend = false) => {
        setSaving(true);
        try {
            let res;
            let payload = { ...formData };
            const validCanBoList = canBoList.filter(cb => cb.ten || cb.donVi);
            payload.canBoHuongDan = validCanBoList.map(cb => {
                const vaiTroLabel = cb.vaiTro !== null && cb.vaiTro !== undefined ? (objectLoaiCanBoHuongDan.find(x => x.value === cb.vaiTro)?.label || '') : '';
                const parts = [cb.ten, cb.donVi];
                if (vaiTroLabel) parts.push(vaiTroLabel);
                return parts.filter(Boolean).join(' - ');
            }).join('\n');
            if (validCanBoList.length > 0 && validCanBoList[0].vaiTro !== null && validCanBoList[0].vaiTro !== undefined) {
                payload.loaiCanBoHuongDan = validCanBoList[0].vaiTro;
            }

            if (isSend) {
                payload.trangThaiGuiKetQua = trangThaiGuiKetQuaValue.daGui;
            } else if (!payload.trangThaiGuiKetQua || payload.trangThaiGuiKetQua === 0 || payload.trangThaiGuiKetQua === '0' || payload.trangThaiGuiKetQua === trangThaiGuiKetQuaValue.chuaGui) {
                payload.trangThaiGuiKetQua = trangThaiGuiKetQuaValue.chuaGui;
            }
            if (payload.id) {
                res = await Put(KETQUATUYENSINH_API.UPDATE_ITEM, payload.id, payload);
            } else {
                res = await Post(KETQUATUYENSINH_API.CREATE_ITEM, null, payload);
            }

            if (res && res.ok) {
                toast.success(isSend ? 'Gửi kết quả tuyển sinh thành công!' : 'Lưu kết quả tuyển sinh thành công!');
                refetch();
            } else {
                toast.error(res?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
            }
        } catch (error) {
            console.error(error);
            toast.error('Lỗi kết nối máy chủ!');
        } finally {
            setSaving(false);
            setShowConfirm(false);
        }
    };

    const handleOpenConfirm = () => {
        setShowConfirm(true);
    };

    if (isLoading) {
        return (
            <div className="text-center py-4">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2 text-muted">Đang tải dữ liệu kết quả...</p>
            </div>
        );
    }

    const isDaGui = formData.trangThaiGuiKetQua === trangThaiGuiKetQuaValue.daGui || formData.trangThaiGuiKetQua === 'DaGui' || formData.trangThaiGuiKetQua === 1;

    if (readOnly) {
        const FieldDisplay = ({ label, value, highlight }) => (
            <div className="mb-3">
                <div className="text-secondary small font-weight-bold mb-1">{label}</div>
                <div className={highlight ? "text-primary" : "text-dark"} style={{ fontSize: '15px', fontWeight: highlight ? '600' : '500', wordBreak: 'break-word', minHeight: '24px' }}>
                    {value !== null && value !== undefined && value !== '' ? value : <span className="text-muted font-italic" style={{ fontWeight: 'normal' }}>Chưa cập nhật</span>}
                </div>
            </div>
        );

        const FieldDisplayFile = ({ label, value }) => {
            const getSafeUrl = (path) => {
                if (!path) return null;
                if (path.startsWith('http')) return path;
                const baseUrl = BaseGatewayImage && BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : (BaseGatewayImage || '');
                const safePath = path.startsWith('/') ? path : `/${path}`;
                return `${baseUrl}${safePath}`;
            };
            let files = [];
            if (value) {
                try {
                    const parsed = JSON.parse(value);
                    if (Array.isArray(parsed)) files = parsed;
                    else files = [{ filePath: value, name: value.split('/').pop() }];
                } catch (e) {
                    files = [{ filePath: value, name: value.split('/').pop() }];
                }
            }
            return (
                <div className="mb-3">
                    {label && <div className="text-secondary small font-weight-bold mb-1">{label}</div>}
                    <div className="d-flex flex-wrap">
                        {files.length > 0 ? (
                            files.map((file, idx) => {
                                const path = file.filePath || file;
                                let name = file.name || (typeof path === 'string' ? path.split('/').pop() : 'File');
                                name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                                return (
                                    <a key={idx} href={getSafeUrl(path)} target="_blank" rel="noreferrer" className="btn btn-outline-primary text-left btn-sm mb-1 mr-1" style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                        <i className="fas fa-paperclip mr-1"></i> {name}
                                    </a>
                                );
                            })
                        ) : <span className="text-muted font-italic small">Không có file đính kèm</span>}
                    </div>
                </div>
            );
        };

        const getLabel = (val, enumList) => {
            const item = enumList.find(x => x.value === val);
            return item ? item.label : val;
        };

        const getKetQuaLabel = (val) => {
            const item = objectKetQuaTuyenSinh.find(x => x.value === val);
            if (!item) return <span className="text-muted font-italic">Chưa cập nhật</span>;
            return <span className={`text-${item.color} font-weight-bold`}>{item.label}</span>;
        };

        return (
            <div className="bg-white p-4 border rounded mx-3 mb-4 mt-3" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                <h5 className="font-weight-bold text-success mb-3 border-bottom pb-2"><i className="fas fa-award mr-2"></i> Quyết định kết quả tuyển sinh</h5>
                
                <div className="text-dark p-2" style={{ fontSize: '15px', lineHeight: '1.8' }}>
                    <div className="mb-2"><strong>Trạng thái tuyển sinh:</strong> <span className="ml-2">{getKetQuaLabel(formData.ketQua)}</span></div>
                    
                    {loaiTuyenSinh === 0 && (
                        <>
                            <div className="mb-2"><strong>Số Quyết định công nhận NCS:</strong> <span className="ml-2">{formData.soQuyetDinh || 'Chưa cấp'}</span></div>
                            <div className="mb-2"><strong>Ngày quyết định:</strong> <span className="ml-2">{formData.ngayQuyetDinh ? new Date(formData.ngayQuyetDinh).toLocaleDateString('vi-VN') : 'Chưa cấp'}</span></div>
                            <div className="mb-2 d-flex flex-wrap">
                                <div className="mr-5 mb-1"><strong>Điểm hồ sơ:</strong> <span className="ml-2 text-danger font-weight-bold">{formData.diemHoSo}</span></div>
                                <div className="mr-5 mb-1"><strong>Điểm đề cương:</strong> <span className="ml-2 text-danger font-weight-bold">{formData.diemXetTuyen}</span></div>
                                <div className="mr-5 mb-1"><strong>Điểm tổng:</strong> <span className="ml-2 text-danger font-weight-bold">{formData.diemTong}</span></div>
                            </div>
                            
                            <div className="mb-2 d-flex flex-wrap">
                                <div className="mr-5 mb-1"><strong>Mã ngành:</strong> <span className="ml-2">{selectedNganh ? selectedNganh.maNganh || selectedNganh.MaNganh : ''}</span></div>
                                <div className="mr-5 mb-1"><strong>Ngành:</strong> <span className="ml-2">{selectedNganh ? selectedNganh.tenNganh || selectedNganh.TenNganh : ''}</span></div>
                                {hasChuyenNganh && (
                                    <div className="mb-1"><strong>Chuyên ngành:</strong> <span className="ml-2">{selectedChuyenNganh ? selectedChuyenNganh.tenChuyenNganh || selectedChuyenNganh.TenChuyenNganh : ''}</span></div>
                                )}
                            </div>

                            <div className="mb-2"><strong>Hình thức đào tạo:</strong> <span className="ml-2">{hinhThucOptions.find(x => (x.id || x.Id) === formData.hinhThucDaoTaoId)?.tenHinhThuc || hinhThucOptions.find(x => (x.id || x.Id) === formData.hinhThucDaoTaoId)?.TenHinhThuc || ''}</span></div>
                            <div className="mb-2"><strong>Thời hạn đào tạo:</strong> <span className="ml-2">{getLabel(formData.thoiHanDaoTao, objectThoiHanDaoTao)}</span></div>
                            <div className="mb-2"><strong>Thời gian đào tạo:</strong> <span className="ml-2">{
                                (formData.tuNgay ? new Date(formData.tuNgay).toLocaleDateString('vi-VN') : '...') 
                                + ' - ' + 
                                (formData.denNgay ? new Date(formData.denNgay).toLocaleDateString('vi-VN') : '...')
                            }</span></div>

                            <div className="mb-2">
                                <strong>Cán bộ hướng dẫn - Đơn vị công tác - Vai trò cán bộ:</strong> 
                                <div className="mt-1 ml-3" style={{ lineHeight: '1.6' }}>
                                    {canBoList && canBoList.length > 0 ? (
                                        canBoList.map((cb, idx) => {
                                            const role = objectLoaiCanBoHuongDan.find(x => x.value === cb.vaiTro)?.label || cb.vaiTro;
                                            const line = [cb.ten || cb.hoTen, cb.donVi || cb.donViCongTac, role].filter(Boolean).join(' - ');
                                            return <div key={idx}>{idx + 1}. {line}</div>;
                                        })
                                    ) : <span className="text-muted font-italic">Không có</span>}
                                </div>
                            </div>

                            <div className="mt-4 mb-2"><strong>Thông báo nhập học:</strong></div>
                            <div className="mb-3" dangerouslySetInnerHTML={{ __html: formData.thongBaoNhapHoc || '<span class="text-muted">Không có thông báo</span>' }}></div>
                            
                            <div className="mt-4 mb-2"><strong>File quyết định đính kèm:</strong></div>
                            <div className="mb-3">
                                <FieldDisplayFile value={formData.fileQuyetDinh} />
                            </div>
                        </>
                    )}

                    {loaiTuyenSinh !== 0 && (
                        <>
                            <div className="mb-2"><strong>Tên khóa học:</strong> <span className="ml-2">{dataKhoaHoc?.tenKhoaHoc || dataKhoaHoc?.TenKhoaHoc}</span></div>
                            <div className="mb-2"><strong>Số Quyết định công nhận học viên:</strong> <span className="ml-2">{formData.soQdCongNhanHocVien || 'Chưa cấp'}</span></div>
                            <div className="mb-2"><strong>Ngày quyết định:</strong> <span className="ml-2">{formData.ngayQdCongNhanHocVien ? new Date(formData.ngayQdCongNhanHocVien).toLocaleDateString('vi-VN') : 'Chưa cấp'}</span></div>
                            
                            <div className="mb-2 d-flex flex-wrap">
                                <div className="mr-5 mb-1"><strong>Điểm thi lý thuyết:</strong> <span className="ml-2 text-danger font-weight-bold">{formData.diemThiLyThuyet}</span></div>
                                <div className="mr-5 mb-1"><strong>Điểm thi thực hành:</strong> <span className="ml-2 text-danger font-weight-bold">{formData.diemThiThucHanh}</span></div>
                                <div className="mr-5 mb-1"><strong>Điểm tổng:</strong> <span className="ml-2 text-danger font-weight-bold">{formData.diemTong}</span></div>
                            </div>
                            
                            <div className="mb-2"><strong>Thời gian đào tạo:</strong> <span className="ml-2">{
                                (formData.tuNgay ? new Date(formData.tuNgay).toLocaleDateString('vi-VN') : '...') 
                                + ' - ' + 
                                (formData.denNgay ? new Date(formData.denNgay).toLocaleDateString('vi-VN') : '...')
                            }</span></div>

                            <div className="mt-4 mb-2"><strong>Thông báo nhập học:</strong></div>
                            <div className="mb-3" dangerouslySetInnerHTML={{ __html: formData.thongBaoNhapHoc || '<span class="text-muted">Không có thông báo</span>' }}></div>
                            
                            <div className="mt-4 mb-2"><strong>File quyết định đính kèm:</strong></div>
                            <div className="mb-3">
                                <FieldDisplayFile value={formData.fileQuyetDinh} />
                            </div>
                        </>
                    )}

                    <div className="mt-4 mb-2"><strong>Ghi chú:</strong></div>
                    <div className="mb-3" dangerouslySetInnerHTML={{ __html: formData.ghiChu || '<span class="text-muted">Không có ghi chú</span>' }}></div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-light p-3 rounded border mt-3">
            <h5 className="font-weight-bold text-success mb-4"><i className="fas fa-award mr-2"></i> Quyết định kết quả tuyển sinh</h5>
            
            {/* <Alert variant="info" className="small">
                <i className="fas fa-info-circle mr-1"></i> Các điểm số bên dưới được hệ thống tự động đồng bộ từ tab <strong>Kết quả đánh giá thí sinh</strong>.
            </Alert> */}

            <Row>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Kết quả <span className="text-danger">*</span></Form.Label>
                        <div>
                            {objectKetQuaTuyenSinh.map((item, idx) => (
                                <div key={idx} style={{ display: 'inline-block', marginRight: '3rem', pointerEvents: readOnly ? 'none' : 'auto' }}>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id={`ketQua_${item.value}`}
                                        label={<span className={`text-${item.color}`} style={{ fontWeight: 500 }}>{item.label}</span>}
                                        name="ketQua"
                                        value={item.value}
                                        checked={formData.ketQua === item.value}
                                        onChange={(e) => !readOnly && setFormData({ ...formData, ketQua: parseInt(e.target.value) })}
                                        tabIndex={readOnly ? -1 : 0}
                                        style={{ marginRight: 0 }}
                                    />
                                </div>
                            ))}
                        </div>
                    </Form.Group>
                </Col>

                {loaiTuyenSinh === 0 && (
                    <>
                        <Col md={12}>
                            <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Số Quyết định công nhận NCS</Form.Label>
                        <Form.Control 
                            type="text" 
                            placeholder="Nhập số quyết định..."
                            value={formData.soQuyetDinh} 
                            onChange={(e) => setFormData({ ...formData, soQuyetDinh: e.target.value })}
                            disabled={readOnly}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Ngày quyết định</Form.Label>
                        <Form.Control 
                            type="date" 
                            value={formData.ngayQuyetDinh || ''} 
                            onChange={(e) => setFormData({ ...formData, ngayQuyetDinh: e.target.value })}
                            disabled={readOnly}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Điểm hồ sơ</Form.Label>
                        <Form.Control 
                            type="text" 
                            disabled 
                            value={formData.diemHoSo !== undefined && formData.diemHoSo !== null ? formData.diemHoSo : 'Chờ cập nhật...'} 
                            className="bg-white font-weight-bold text-danger"
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Điểm đề cương (Xét tuyển)</Form.Label>
                        <Form.Control 
                            type="text" 
                            disabled 
                            value={formData.diemXetTuyen !== undefined && formData.diemXetTuyen !== null ? formData.diemXetTuyen : 'Chờ cập nhật...'} 
                            className="bg-white font-weight-bold text-danger"
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Điểm tổng</Form.Label>
                        <Form.Control 
                            type="text" 
                            disabled 
                            value={formData.diemTong !== undefined && formData.diemTong !== null ? formData.diemTong : 'Chờ cập nhật...'} 
                            className="bg-white font-weight-bold text-primary"
                        />
                    </Form.Group>
                </Col>
                    </>
                )}
            </Row>

            {loaiTuyenSinh === 0 && (
            <Row className="mt-3">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Mã ngành</Form.Label>
                        <Form.Control 
                            type="text" 
                            disabled
                            value={selectedNganh ? (selectedNganh.maNganh || selectedNganh.MaNganh || '') : ''} 
                            className="bg-white"
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Ngành đào tạo</Form.Label>
                        <Form.Control 
                            type="text" 
                            disabled
                            value={selectedNganh ? (selectedNganh.tenNganh || selectedNganh.TenNganh || '') : ''} 
                            className="bg-white"
                        />
                    </Form.Group>
                </Col>
                {hasChuyenNganh && (
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label style={{ fontWeight: 500 }}>Chuyên ngành đào tạo</Form.Label>
                            <Form.Control 
                                type="text" 
                                disabled
                                value={selectedChuyenNganh ? (selectedChuyenNganh.tenChuyenNganh || selectedChuyenNganh.TenChuyenNganh || '') : ''} 
                                className="bg-white"
                            />
                        </Form.Group>
                    </Col>
                )}
                <Col md={6}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Hình thức đào tạo</Form.Label>
                        <Form.Control 
                            as="select" 
                            value={formData.hinhThucDaoTaoId || ''} 
                            onChange={(e) => setFormData({ ...formData, hinhThucDaoTaoId: e.target.value })}
                            disabled={readOnly}
                        >
                            <option value="">-- Chọn hình thức đào tạo --</option>
                            {hinhThucOptions.map((item, idx) => (
                                <option key={idx} value={item.id || item.Id}>{item.tenHinhThuc || item.TenHinhThuc}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Quá trình đào tạo áp dụng theo Thông tư</Form.Label>
                        <Form.Control 
                            type="text" 
                            placeholder="Nhập thông tư..."
                            value={formData.quyCheDaoTao} 
                            onChange={(e) => setFormData({ ...formData, quyCheDaoTao: e.target.value })}
                            disabled={readOnly}
                        />
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Tên đề tài</Form.Label>
                        <Form.Control 
                            type="text" 
                            placeholder="Nhập tên đề tài..."
                            value={formData.tenDeTai} 
                            onChange={(e) => setFormData({ ...formData, tenDeTai: e.target.value })}
                            disabled={readOnly}
                        />
                    </Form.Group>
                </Col>

                <Col md={12}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Danh sách cán bộ hướng dẫn</Form.Label>
                        {canBoList.map((cb, idx) => (
                            <div key={idx} className="d-flex align-items-end mb-3">
                                <div style={{ flex: 1 }}>
                                    <small className="font-weight-bold d-block mb-1">Tên cán bộ</small>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Nhập tên cán bộ" 
                                        value={cb.ten} 
                                        onChange={e => {
                                            const newList = [...canBoList];
                                            newList[idx].ten = e.target.value;
                                            setCanBoList(newList);
                                        }} 
                                        disabled={readOnly}
                                    />
                                </div>
                                <span className="mx-2 text-muted pb-2">-</span>
                                <div style={{ flex: 1 }}>
                                    <small className="font-weight-bold d-block mb-1">Đơn vị công tác</small>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Nhập đơn vị công tác" 
                                        value={cb.donVi} 
                                        onChange={e => {
                                            const newList = [...canBoList];
                                            newList[idx].donVi = e.target.value;
                                            setCanBoList(newList);
                                        }} 
                                        disabled={readOnly}
                                    />
                                </div>
                                <span className="mx-2 text-muted pb-2">-</span>
                                <div style={{ flex: 1 }}>
                                    <small className="font-weight-bold d-block mb-1">Vai trò cán bộ</small>
                                    <Form.Control 
                                        as="select" 
                                        value={cb.vaiTro === null || cb.vaiTro === undefined ? '' : cb.vaiTro} 
                                        onChange={e => {
                                            const newList = [...canBoList];
                                            newList[idx].vaiTro = e.target.value ? parseInt(e.target.value) : null;
                                            setCanBoList(newList);
                                        }} 
                                        disabled={readOnly}
                                    >
                                        <option value="">-- Chọn vai trò --</option>
                                        {objectLoaiCanBoHuongDan.map((opt, i) => (
                                            <option key={i} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </Form.Control>
                                </div>
                                {!readOnly && (
                                    <Button 
                                        variant="outline-danger" 
                                        className="ml-2" 
                                        style={{ height: '38px' }}
                                        onClick={() => setCanBoList(canBoList.filter((_, i) => i !== idx))}
                                        title="Xóa cán bộ"
                                    >
                                        <i className="fas fa-trash"></i>
                                    </Button>
                                )}
                            </div>
                        ))}
                        {!readOnly && (
                            <Button 
                                variant="outline-primary" 
                                size="sm" 
                                className="mt-1" 
                                onClick={() => setCanBoList([...canBoList, { ten: '', donVi: '', vaiTro: null }])}
                            >
                                <i className="fas fa-plus mr-1"></i> Thêm cán bộ hướng dẫn
                            </Button>
                        )}
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label className="d-block" style={{ fontWeight: 500 }}>Thời hạn đào tạo tiêu chuẩn</Form.Label>
                        <div>
                            {objectThoiHanDaoTao.map((item, idx) => (
                                <div key={idx} style={{ display: 'inline-block', marginRight: '5rem', pointerEvents: readOnly ? 'none' : 'auto' }}>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id={`thoiHanDaoTao_${item.value}`}
                                        label={item.label}
                                        name="thoiHanDaoTao"
                                        value={item.value}
                                        checked={formData.thoiHanDaoTao === item.value}
                                        onChange={(e) => !readOnly && setFormData({ ...formData, thoiHanDaoTao: parseInt(e.target.value) })}
                                        tabIndex={readOnly ? -1 : 0}
                                        style={{ marginRight: 0 }}
                                    />
                                </div>
                            ))}
                        </div>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Từ ngày</Form.Label>
                        <Form.Control 
                            type="date" 
                            value={formData.tuNgay} 
                            onChange={(e) => setFormData({ ...formData, tuNgay: e.target.value })}
                            disabled={readOnly}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500 }}>Đến ngày</Form.Label>
                        <Form.Control 
                            type="date" 
                            value={formData.denNgay} 
                            onChange={(e) => setFormData({ ...formData, denNgay: e.target.value })}
                            disabled={readOnly}
                        />
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Thông báo nhập học</Form.Label>
                        <Editor
                            key={formData.id || 'new'}
                            name="thongBaoNhapHoc"
                            value={formData.thongBaoNhapHoc}
                            onChange={(val) => setFormData({ ...formData, thongBaoNhapHoc: val })}
                            disabled={readOnly}
                        />
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <div className="mt-2">
                        <DocumentInput 
                            labelTitle="File quyết định đính kèm"
                            multiple={true}
                            value={formData.fileQuyetDinh}
                            onChangeProp={(val) => setFormData({ ...formData, fileQuyetDinh: typeof val === 'string' ? val : JSON.stringify(val) })}
                            disabled={readOnly}
                        />
                    </div>
                </Col>
            </Row>
            )}

            <Row className="mt-3">
                <Col md={12}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Ghi chú</Form.Label>
                        <Editor
                            key={formData.id ? `ghiChu-${formData.id}` : 'ghiChu-new'}
                            name="ghiChu"
                            value={formData.ghiChu}
                            onChange={(val) => setFormData({ ...formData, ghiChu: val })}
                            disabled={readOnly}
                        />
                    </Form.Group>
                </Col>
            </Row>
            
            {!readOnly && (
                <div className="text-right mt-3">
                    <Button variant="success" onClick={() => handleSave(false)} disabled={saving}>
                        {saving ? <><Spinner size="sm" animation="border" className="mr-2" /> Đang lưu...</> : <><i className="fas fa-save mr-2"></i> Lưu kết quả</>}
                    </Button>
                    <Button variant="primary" className="ml-2" onClick={handleOpenConfirm} disabled={saving}>
                        {saving ? <><Spinner size="sm" animation="border" className="mr-2" /> Đang gửi...</> : <><i className="fas fa-paper-plane mr-2"></i> {isDaGui ? 'Gửi lại kết quả' : 'Gửi kết quả'}</>}
                    </Button>
                </div>
            )}

            <ConfirmModal
                isOpen={showConfirm}
                title="Xác nhận gửi kết quả"
                content={
                    <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        Lưu ý: Khi gửi quyết định này, thông tin kết quả tuyển sinh sẽ được gửi tới thí sinh. Bạn có chắc chắn muốn gửi?
                    </div>
                }
                labelAccept="Đồng ý gửi"
                handleAccept={() => handleSave(true)}
                handleCancel={() => setShowConfirm(false)}
            />
        </div>
    );
};

export default KetQuaTuyenSinhTab;
